import { render, staticRenderFns } from "./setType4Template.vue?vue&type=template&id=49297a74&scoped=true"
import script from "./setType4Template.vue?vue&type=script&lang=js"
export * from "./setType4Template.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49297a74",
  null
  
)

export default component.exports